import React, {useCallback, useEffect, useMemo, useState} from "react";
import z from "../configZone.json";
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const ZoneWrapper = () => {

    const lvl3 = useMemo(() => ({
            name: z.refTitle,
            items: z.refs[0]?.map((name, value) => ({name, value}))
        }), [])

    return (
        <Form>
            <div>
                <h2>{z.header}</h2>
                <p>{z.description}</p>
            </div>
            <Container fluid className="mb-4 pt-2 pb-4 border border-primary rounded">
                <div><h3>{z.gas.header}</h3></div>
                <div>{z.gas.description}</div>
                <Row className="no-gutters">
                    {z.items.map((v,k) => 
                        <Col lg={6} key={k}>
                            <div className={"h-100 p-3 my-3 mx-2 border border-primary rounded"}>
                                    <ZoneOne value={v.value} name={v.name}
                                        items={v.items.concat(lvl3)}
                                    />
                            </div>
                        </Col>
                    )}
                </Row>
            </Container>
            <DefWater/>
        </Form>
    );
}



const ZoneOne = props => {

    const {value, name, items} = props

    const [data, setData] = useState(null);
    const [refNumber, setRefNumber] = useState(0);
    const [result, setResult] = useState(0);

    useEffect(() => {
        if (data?.[`0`] !== undefined && data?.[`1`] !== undefined){
            let r = value + data[`0`] + data[`1`];
            setRefNumber(r);
            if (data?.[`2`] !== undefined) {
                setResult(z.refs_with_spaces[r][data[`2`]]);
            } else {
                setResult(0);                
            }
        } else {
            setRefNumber(0);
            setResult(0);                
        }
    }, [data, value, items])
    

    const handleChange = useCallback(({k,v}) => {
        setData(d => d ? {...d, [`${k}`]: v} : {[`${k}`]: v})
    }, [])

    const getResult = useCallback(r => 
        z.messages.map(v => v.key).includes(r) ? z.messages.find(v => v.key===r)?.value : r ? r : ""
    , [])

    const ItemsBlock = ({v,k}) => 
        <fieldset className="mb-3">
            <legend>{v.name}</legend>
            {v.items.map((vv) => 
                <Form.Check  key={vv.value}
                    type={"radio"}
                    id={`id_${value}_${k}_${vv.value}`}
                    name={`name_${value}_${k}`}
                    label={vv.name}
                    checked={data?.[`${k}`] === vv.value}
                    onChange={() => handleChange({k,v:vv.value})}
                />
            )}
        </fieldset>

    return (
        <Row >
            <Col sm={12}>
                <h4>{name}</h4>
            </Col>
            <Col sm={6}>
                {items.slice(0,2).map((v,k) => 
                    <ItemsBlock key={k} v={v} k={k} />
                )}
            </Col>
            <Col sm={6}>
                {items.slice(2).map((v,k) => 
                    <ItemsBlock key={k+2} v={v} k={k+2} />
                )}
            </Col>
            <Col lg={12}>
                <h5>{"VÝSLEDOK"}</h5>
                <p>{`Referenčné číslo: `}<strong>{refNumber || ""}</strong></p>
                <p>{`Toxický rozptyl - veľkosť zóny zasiahnutia v metroch: `}<strong>{getResult(result)}</strong></p>
            </Col>
        </Row>
    );
}

const DefWater = () => {

    const [result, setResult] = useState(null);

    const handleChange = k => setResult(k)
    
    return (
        <Container fluid className="mb-3 pt-2 pb-4 border border-primary rounded">
            <div><h3>{z.water.header}</h3></div>
            <div className="mb-3">{z.water.description}</div>
            <Row className="mb-3">
                {z.water.items.map((v,k) => 
                    <Col lg={12} key={k}>
                        <Row className="justify-content-between">
                            <Col md={"10"}>{v.description}</Col>
                            <Col md={"2"}>
                                <Form.Check
                                    type={"radio"}
                                    id={`id_def_${k}`}
                                    name={`name_def_${k}`}
                                    label={v.condition}
                                    checked={result === k}
                                    onChange={() => handleChange(k)}
                                />
                            </Col>
                        </Row>
                    </Col>
                )}
            </Row>
            <Row>
                <Col>
                    <h5>{"VÝSLEDOK"}</h5>
                    <p>{"Výsledok - polomer alebo zasiahnutá plocha "} <strong>{z.water.items[result]?.message || ""}</strong>.</p>
                </Col>
            </Row>
        </Container>
    );

}



export default ZoneWrapper;


